import React, { useMemo } from 'react';

import LoadingSpinner from 'components/LoadingSpinner';
import { classNames } from 'utils/functions';

const colorClasses = {
  title: 'text-primary-600 border-primary-600',
  bg: 'bg-primary-600 shadow-primary-600/50',
};

export default function OptionsGraphComponent({
  data,
  total,
  transform,
  isLoading,
}: {
  data: any;
  total: number;
  transform?: (value: string) => string;
  isLoading: boolean;
}) {
  const options = useMemo(() => {
    return data ? Object.keys(data)?.filter((key) => key !== '') : [];
  }, [data]);

  return (
    <>
      {isLoading ? (
        <div className="flex flex-1 justify-center">
          <LoadingSpinner content="Buscando información" />
        </div>
      ) : !data || options.length === 0 ? (
        <div className="flex flex-1 justify-center">No se encontraron datos</div>
      ) : (
        <div className="flex">
          <div className="flex flex-col space-y-1 border-r-2 border-gray-400 pr-3">
            {options.map((key: string) => (
              <p key={key}>{transform ? transform(key) : key}</p>
            ))}
          </div>
          <div className="flex flex-1 flex-col space-y-4 px-3 pt-[6px]">
            {options.map((key: string) => (
              <div
                key={key}
                className={classNames(colorClasses.bg, 'h-3 rounded-xl shadow-md')}
                style={{
                  width: `${(data?.[key] / total) * 100}%`,
                }}
              />
            ))}
          </div>
          <div className="flex flex-col space-y-1">
            {options.map((key: string) => (
              <div key={key}>{data?.[key]}</div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
